module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "ligth": ""
    }
  }, [(_vm.showMenu) ? _c('v-navigation-drawer', {
    attrs: {
      "id": "navigation-1",
      "fixed": "",
      "mini-variant": _vm.miniVariant,
      "clipped": _vm.clipped,
      "app": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.miniVariant = !_vm.miniVariant
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile-content')], 1), _vm._v(" "), _vm._l((_vm.menuApp), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "active-class": "itemmenu--text",
        "to": item.to,
        "value": item.active,
        "exact": ""
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(" " + _vm._s(item.title))])], 1)], 1)
  }), _vm._v(" "), (_vm.logado == null) ? _c('v-list-tile', {
    attrs: {
      "active-class": "itemmenu--text",
      "to": "/",
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Entrar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.logado != null) ? _c('v-list-tile', {
    attrs: {
      "active-class": "itemmenu--text",
      "to": "/redefinir-senha",
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("password")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Alterar Senha")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.logado != null) ? _c('v-list-tile', {
    attrs: {
      "active-class": "itemmenu--text",
      "exact": ""
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Sair")])], 1)], 1) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "fixed": "",
      "app": "",
      "clipped-left": _vm.clipped,
      "color": "primary"
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    attrs: {
      "dark": ""
    }
  }, [_c('a', {
    staticClass: "linkTitulo",
    attrs: {
      "target": "_empresaOut",
      "href": _vm.linkEmpresa
    }
  }, [_vm._v(_vm._s(_vm.tituloApp))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.menuApp), function(item, i) {
    return _c('v-toolbar-items', {
      key: i,
      staticClass: "hidden-sm-and-down"
    }, [(item.to && !item.menuPai) ? _c('v-btn', {
      attrs: {
        "flat": "",
        "router": "",
        "to": item.to
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!item.to) ? _c('v-menu', {
      attrs: {
        "attach": "",
        "bottom": "",
        "left": "",
        "offset-y": "",
        "max-height": "500"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      slot: "activator"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _c('v-list', _vm._l((item.filhos), function(filho, f) {
      return _c('v-list-tile', {
        key: f,
        attrs: {
          "flat": "",
          "router": "",
          "to": filho.to
        }
      }, [_c('v-list-tile-title', [_vm._v(_vm._s(filho.title))])], 1)
    }))], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "bottom": "",
      "origin": "top right",
      "transition": "v-scale-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list', [(_vm.logado != null) ? _c('v-list-tile', {
    attrs: {
      "to": "/redefinir-senha"
    }
  }, [_c('v-list-tile-title', [_vm._v("Alterar Senha")])], 1) : _vm._e(), _vm._v(" "), (_vm.logado == null) ? _c('v-list-tile', {
    attrs: {
      "to": "/"
    }
  }, [_c('v-list-tile-title', [_vm._v("Entrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.logado != null) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Sair")])], 1) : _vm._e()], 1)], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-content', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9584a48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 386
// module chunks = 1